export enum ThirdPartyMessageType {
    bittiumToFysiologic = 'bittiumToFysiologic',
    createJiraIssue = 'createJiraIssue',
    dgtlHealth = 'dgtlHealth',
    ectosenseCreateTest = 'ectosenseCreateTest',
    ectosenseDeleteTest = 'ectosenseDeleteTest',
    ectosenseSendInvitation = 'ectosenseSendInvitation',
    email = 'email',
    embloom = 'embloom',
    embloomResend = 'embloomResend',
    fysiologic = 'fysiologic',
    hl7 = 'hl7',
    holterDataFile = 'holterDataFile',
    holterDiary = 'holterDiary',
    holterEdfMetadata = 'holterEdfMetadata',
    holterOrder = 'holterOrder',
    holterRecording = 'holterRecording',
    holterXml = 'holterXml',
    interapy = 'interapy',
    medlab = 'medlab',
    medspe = 'medspe',
    medvri = 'medvri',
    optoconnect = 'optoconnect',
    referralPatient = 'referralPatient',
    therapielandAbortInvitation = 'therapielandAbortInvitation',
    therapielandCreateInvitation = 'therapielandCreateInvitation',
    therapielandMigratedReference = 'therapielandMigratedReference',
    therapielandProvisioning = 'therapielandProvisioning',
}
